import { API_VALIDADOR as API } from "@/api";
import axios from "axios";

class OrderService {
  getOrderList(params = {}) {
    const response = axios.get(API.order_list, {
      params
    });
    return response;
  }

  downloadOrderCSV(params = {}) {
    return axios.get(API.order_download_csv, {
      params,
      responseType: "blob"
    });
  }

  getOrderProductList() {
    const response = axios.get(API.order_products, {
      params: {
        fields: "id,name"
      }
    });
    return response;
  }

  postOrderRecompensa(data) {
    const response = axios.post(API.order_recompensa, data);
    return response;
  }
  getOrderRecompensaList(params = {}) {
    const response = axios.get(API.order_recompensa_list, { params });
    return response;
  }
  downloadOrderRecompensaCSV(params = {}) {
    return axios.get(API.order_recompensa_download_csv, {
      params,
      responseType: "blob"
    });
  }
}

const instance = new OrderService();
export default instance;
